import React from "react";
import { useState, useEffect, useRef } from "react";
import { Modal, message, Radio } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import sumBy from "lodash/sumBy";
import dayjs from "dayjs";
import db from "../../../../database";
import { getOAuthHeaders } from "../../../../constants/oAuthValidation";
import { checkGiftCard, verifyLoyaltyRedemption } from "../../../../services";
import messages from "../../../../errors/messages.en-IN.json";
import { getApplicablePrice } from "../../../../utils/getPriceList";
import { shouldUseBatchPrice } from "../../../../utils/resolvePricingPolicy";
import { CheckoutFlatDiscount } from "../../Core/PricingRules/CheckoutFlatDiscount";
import { CheckoutTotalManualDiscount } from "../../Core/PricingRules/CheckoutTotalManualDiscount";
import { CheckoutPercentageDiscount } from "../../Core/PricingRules/CheckoutPercentageDiscount";
import { pricingRuleController } from "../../Core/PricingRules/pricingRuleController";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";
import useCartStore from "../../../../stores/useCartStore";
import useTransactionStore from "../../../../stores/useTransactionStore";
import { v4 as uuidv4 } from "uuid";
import { getPricingRules, findPricingRuleById } from "../../../../utils/pricingRulesCache";

const useRetailModalsLogic = (props) => {
  const {
    cart,
    setCart,
    inputFocused,
    setInputFocused,
    loyalityOtpModalVisible,
    loyaltyInputRef,
    loyaltyInputValue,
    setLoyaltyInputValue,
    setSelectedPaymentMethod,
    manualDiscountInput,
    setManualDiscountInput,
    selectedManualDiscountType,
    setSelectedManualDiscountType,
    setSelectedManualDiscountTypeValue,
    manualDiscountModalVisible,
    setTotalBillDiscountData,
    selectedExternalCouponType,
    couponModalVisible,
    selectedCoupon,
    setTotalBillCouponData,
    salesRepModalOpen,
    displayManualQtyWeightInput,
    setProductWeightModalInput,
    validateGiftCard,
    validateGiftCardForm,
    giftCardForm,
    giftCardFlag,
    amount,
    CardPaymentForm,
    isCardPaymentFlag,
    giftCardBalance,
    addToBagFlag,
    selectBagRef,
    isGiftCardFlag,
    addCashFlag,
    cashAddInFlag,
    posConfig,
    setCashOut,
    setCashIn,
    setPettyCashOut,
    setPettyCashIn,
    cashManagementForm,
    showSaleType,
    selectedSaleType,
    setSelectedSaleType,
    setSelectedSaleTypeData,
    tillData,
    giftCardItems,
    searchTerm,
    giftCardType,
    addToBagProducts,
    setGiftCardItems,
    setSearchTerm,
    setGiftCardBalance,
    setSelectGiftCardItem,
    setIsGiftCardFlag,
    setValidateGiftCard,
    setIsSaleTypeFlag,
    changeCustomerId,
    getFilteredPaymentMethods,
    setShowPayments,
    orderType,
    processBillDiscounts,
    openPaymentModalByCustomer,
    manualDiscountTypes,
    searchInputRef,
    checkLoyality,
    removeCoupon,
    offersDrawerOpen,
  } = props;

  const isExchange = useTransactionStore.getState().selectedReturnType === "EXCHANGE";
  const currenciesList = tillData.tillAccess.csBunit.currencies;

  const issueCardInput = document.getElementById("issueCardInput");
  const issueCardAmount = document.getElementById("issueCardAmount");
  const reddemNumber = document.getElementById("redeemNumber");
  const pinNumb = document.getElementById("pin");
  const pinCard = document.getElementById("cardPin");
  const redeemAmountNumber = document.getElementById("amountNumber");

  const amountInputRef = useRef(null);
  const salesRepModalInputRef = useRef();
  const manualDiscountInputRef = useRef();
  const authorizationRef = useRef(null);
  const valueInputRef = useRef(null);

  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [offerDetailsOpen, setOfferDetailsOpen] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [expenseCategories, setExpenseCategories] = useState([]);
  const [financialAccounts, setFinancialAccounts] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [externalCoupons, setExternalCoupons] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [selectedQty, setSelectedQty] = useState(1);
  const [saleTypeData, setSaleTypeData] = useState([]);
  const [filteredGiftCards, setFilteredGiftCards] = useState([]);
  const [filtredBags, setFilteredBags] = useState([]);
  const [focusedField, setFocusedField] = useState(null);

  let uniqReferenceId = uuidv4().replace(/-/g, "").toUpperCase();

  // ─── Effects ────────────────────────────────────────────────────────────────

  useEffect(() => {
    const allRules = getPricingRules();
    const rules = allRules.filter((rule) => rule.externalCoupon === "Y");
    setExternalCoupons(rules);
  }, []);

  useEffect(() => {
    if (posConfig?.cashOut !== "Y" && posConfig?.allowPettyCashExpenses === "Y") {
      let formData = cashManagementForm.getFieldsValue(true);
      formData.type = "pettyCashOut";
      setCashOut(false);
      cashManagementForm.setFieldsValue({ pettyCashOut: true, type: "pettyCashOut" });
    }
    if (posConfig?.cashOut !== "Y" && posConfig?.allowPettyCashExpenses !== "Y" && posConfig?.enableBankTransferInCashOut === "Y") {
      let formData = cashManagementForm.getFieldsValue(true);
      formData.type = "bankTransfer";
      setCashOut(false);
      setPettyCashOut(false);
      cashManagementForm.setFieldsValue({ bankTransfer: true, type: "bankTransfer" });
    }
  }, [posConfig]);

  useEffect(() => {
    if (addCashFlag) {
      setTimeout(() => {
        amountInputRef.current?.focus();
      }, 100);
      if (cashAddInFlag) {
        if (posConfig?.cashOut === "Y" && posConfig?.pettyCashOut === "Y") {
          setCashOut(true);
        }
        if (posConfig?.cashOut !== "Y") {
          setPettyCashOut(true);
        }
        if (posConfig?.pettyCashOut !== "Y") {
          setCashOut(true);
        }
      } else {
        if (posConfig?.cashIn === "Y" && posConfig?.allowPettyCashIn === "Y") {
          setCashIn(true);
        }
        if (posConfig?.cashIn !== "Y") {
          setPettyCashIn(true);
        }
        if (posConfig?.allowPettyCashIn !== "Y") {
          setCashIn(true);
        }
      }
    }
  }, [addCashFlag]);

  useEffect(() => {
    if (addToBagFlag) {
      setTimeout(() => {
        selectBagRef.current.focus();
      }, 10);
    }
  }, [addToBagFlag]);

  useEffect(() => {
    if (isCardPaymentFlag) {
      setTimeout(() => {
        authorizationRef?.current?.focus();
      }, 100);
    }
  }, [isCardPaymentFlag]);

  useEffect(() => {
    if (isGiftCardFlag) {
      setTimeout(() => {
        if (selectBagRef?.current) {
          selectBagRef.current.focus();
        }
      }, 10);
    }
  }, [isGiftCardFlag]);

  useEffect(() => {
    (() => {
      let uniqueFinalArray = [];
      if (!selectedManualDiscountType || Object.keys(selectedManualDiscountType).length <= 0) return;
      const activeCart = isExchange && useCartStore.getState().exchangeCart?.items?.length > 0 ? useCartStore.getState().exchangeCart : cart;
      activeCart.items.forEach((addedToCart) => {
        let excludingFlag = true;

        if (addedToCart?.layAway === "Y" && addedToCart?.weight <= 0) {
          excludingFlag = false;
        }

        const matchingCategoy = selectedManualDiscountType?.mPricingPcategories?.find((pc) => pc.mProductCategoryId === addedToCart.mProductCategoryId);

        if (
          (selectedManualDiscountType.excludeProductCategories === "Y" && matchingCategoy) ||
          (selectedManualDiscountType.excludeProductCategories !== "Y" && !matchingCategoy) ||
          (selectedManualDiscountType.excludeProductCategories === "N" && selectedManualDiscountType.mPricingPcategories.length === 0)
        ) {
          excludingFlag = false;
        }

        const matchingProduct = selectedManualDiscountType?.mPricingXProducts?.find((pc) => pc.mProductId === addedToCart.productId);

        if (
          (selectedManualDiscountType.excludeProducts === "Y" && matchingProduct) ||
          (selectedManualDiscountType.excludeProducts !== "Y" && !matchingProduct) ||
          (selectedManualDiscountType.excludeProducts === "N" && selectedManualDiscountType.mPricingXProducts.length === 0)
        ) {
          excludingFlag = false;
        }

        const matchingBrand = selectedManualDiscountType.mPricingBrands.find((pc) => pc.mBrandId === addedToCart.productBrandId);

        if (
          (selectedManualDiscountType.excludeBrands === "Y" && matchingBrand) ||
          (selectedManualDiscountType.excludeBrands !== "Y" && !matchingBrand) ||
          (selectedManualDiscountType.excludeBrands === "N" && selectedManualDiscountType.mPricingBrands.length === 0)
        ) {
          excludingFlag = false;
        }
        if (excludingFlag) uniqueFinalArray.push(addedToCart);
      });

      let totalBillPrice = 0;
      if (uniqueFinalArray.length === activeCart.items.length) {
        totalBillPrice = activeCart.total;
      } else {
        uniqueFinalArray.map((product) => {
          totalBillPrice = totalBillPrice + parseFloat(product.realPrice * Math.abs(product.weight) - product.discount);
        });
      }

      let discountedAmount = 0;
      let finalAmount = 0;

      const parsedDiscountInput = parseFloat(manualDiscountInput);
      if (selectedManualDiscountType.discountType === "V") {
        discountedAmount = parseFloat(parsedDiscountInput);
        finalAmount = activeCart.total - discountedAmount >= 0 ? activeCart.total - discountedAmount : 0;
        discountedAmount = activeCart.total - discountedAmount >= 0 ? discountedAmount : 0;
      } else {
        discountedAmount = ((totalBillPrice + activeCart.discount) * parsedDiscountInput) / 100;
        finalAmount = parsedDiscountInput <= 100 ? activeCart.total + activeCart.discount - discountedAmount : 0;
        discountedAmount = parsedDiscountInput <= 100 ? discountedAmount : 0;
      }
      setTotalBillDiscountData({
        finalAmount,
        discountedAmount,
        totalBillPrice,
      });
    })();
  }, [manualDiscountModalVisible, manualDiscountInput, selectedManualDiscountType]);

  useEffect(() => {
    (() => {
      let uniqueFinalArray = [];
      if (!selectedExternalCouponType || Object.keys(selectedExternalCouponType).length <= 0) return;
      const activeCart = isExchange && useCartStore.getState().exchangeCart?.items?.length > 0 ? useCartStore.getState().exchangeCart : cart;
      activeCart.items.forEach((addedToCart) => {
        let excludingFlag = true;

        if (addedToCart?.layAway === "Y" && addedToCart?.weight <= 0) {
          excludingFlag = false;
        }

        const matchingCategoy = selectedExternalCouponType?.mPricingPcategories?.find((pc) => pc.mProductCategoryId === addedToCart.mProductCategoryId);

        if (
          (selectedExternalCouponType.excludeProductCategories === "Y" && matchingCategoy) ||
          (selectedExternalCouponType.excludeProductCategories !== "Y" && !matchingCategoy) ||
          (selectedExternalCouponType.excludeProductCategories === "N" && selectedExternalCouponType.mPricingPcategories.length === 0)
        ) {
          excludingFlag = false;
        }

        const matchingProduct = selectedExternalCouponType?.mPricingXProducts?.find((pc) => pc.mProductId === addedToCart.productId);

        if (
          (selectedExternalCouponType.excludeProducts === "Y" && matchingProduct) ||
          (selectedExternalCouponType.excludeProducts !== "Y" && !matchingProduct) ||
          (selectedExternalCouponType.excludeProducts === "N" && selectedExternalCouponType.mPricingXProducts.length === 0)
        ) {
          excludingFlag = false;
        }

        const matchingBrand = selectedExternalCouponType.mPricingBrands.find((pc) => pc.mBrandId === addedToCart.productBrandId);

        if (
          (selectedExternalCouponType.excludeBrands === "Y" && matchingBrand) ||
          (selectedExternalCouponType.excludeBrands !== "Y" && !matchingBrand) ||
          (selectedExternalCouponType.excludeBrands === "N" && selectedExternalCouponType.mPricingBrands.length === 0)
        ) {
          excludingFlag = false;
        }
        if (excludingFlag) uniqueFinalArray.push(addedToCart);
      });

      let totalBillPrice = 0;
      if (uniqueFinalArray.length === activeCart.items.length) {
        totalBillPrice = activeCart.total;
      } else {
        uniqueFinalArray.map((product) => {
          totalBillPrice = totalBillPrice + parseFloat(product.realPrice * Math.abs(product.weight) - product.discount);
        });
      }

      let discountedAmount = 0;
      let finalAmount = 0;

      const parsedDiscountInput = parseFloat(manualDiscountInput);
      if (selectedExternalCouponType.discountType === "V") {
        discountedAmount = parseFloat(parsedDiscountInput);
        finalAmount = activeCart.total - discountedAmount >= 0 ? activeCart.total - discountedAmount : 0;
        discountedAmount = activeCart.total - discountedAmount >= 0 ? discountedAmount : 0;
      } else {
        discountedAmount = ((totalBillPrice + activeCart.discount) * parsedDiscountInput) / 100;
        finalAmount = parsedDiscountInput <= 100 ? activeCart.total + activeCart.discount - discountedAmount : 0;
        discountedAmount = parsedDiscountInput <= 100 ? discountedAmount : 0;
      }
      setTotalBillCouponData({
        finalAmount,
        discountedAmount,
        totalBillPrice,
      });
    })();
  }, [manualDiscountInput, selectedCoupon, couponModalVisible]);

  useEffect(() => {
    if (loyalityOtpModalVisible) {
      setTimeout(() => loyaltyInputRef.current?.focus(), 50);
    }
  }, [loyalityOtpModalVisible]);

  useEffect(() => {
    if (salesRepModalOpen.status) {
      setTimeout(() => {
        salesRepModalInputRef.current.focus();
      }, 100);
    }
  }, [salesRepModalOpen.status]);

  useEffect(() => {
    if (displayManualQtyWeightInput) {
      setTimeout(() => {
        const productInput = document.getElementById("sm-amount-input");
        if (productInput) {
          productInput?.focus();
        }
      }, 100);
      getWeightFromHardware();
    }
  }, [displayManualQtyWeightInput]);

  useEffect(() => {
    validateGiftCardForm.resetFields();
  }, [validateGiftCard]);

  useEffect(() => {
    giftCardForm.setFieldsValue({
      amount: amount,
    });
    const productSearchInput = document.getElementById("redeemNumber");
    if (productSearchInput) {
      productSearchInput?.focus();
    }
  }, [giftCardFlag]);

  useEffect(() => {
    let formData = CardPaymentForm.getFieldsValue(true);
    CardPaymentForm.setFieldsValue({
      transactionId: formData?.transactionId ? formData?.transactionId : "",
      cardNumber: formData?.cardNumber ? formData?.cardNumber : "",
      authorization: formData?.authorization ? formData?.authorization : "",
    });
  }, [isCardPaymentFlag]);

  useEffect(() => {
    if (giftCardBalance > 0) {
      giftCardForm.setFieldsValue({
        amount: giftCardBalance > amount ? amount : giftCardBalance,
      });
    }
  }, [giftCardBalance]);

  useEffect(() => {
    setTimeout(() => {
      if (manualDiscountInputRef.current) {
        manualDiscountInputRef.current.focus();
      }
    }, 100);
  }, [selectedManualDiscountType]);

  useEffect(() => {
    if (showSaleType === true) {
      const getSaleTypeData = async () => {
        const saleData = await db.posSaletypes.toArray();
        const filteredSaleData = saleData?.filter(
          (sale) => sale?.cwrSaletype?.fulfilmentType !== "TA" && sale?.cwrSaletype?.fulfilmentType !== "DI" && sale?.cwrSaletype?.fulfilmentType !== "DE"
        );

        setSaleTypeData(filteredSaleData);
        const index = saleData?.findIndex((sale) => sale?.cwrSaletype?.isdefault === "Y");
        if (index >= 0 && selectedSaleType === "") {
          setSelectedSaleType(saleData[index]?.cwrSaletype?.name);
          setSelectedSaleTypeData(saleData[index]);
          usePOSConfigStore.getState().setSaleTypeData(saleData[index]);

          let cartDetails = isExchange ? useCartStore.getState().exchangeCart || {} : cart;
          cartDetails = { ...cartDetails };
          cartDetails.customer = saleData[index]?.customer?.b2cCustomerId ? saleData[index]?.customer : tillData.tillAccess.csBunit.b2cCustomer;
          cartDetails.customer.cwrCustomerId = saleData[index]?.customer?.b2cCustomerId;
          if (isExchange) {
            useCartStore.getState().setExchangeCart(cartDetails);
          } else {
            setCart(cartDetails);
          }
        }
      };

      getSaleTypeData();
    }
  }, []);

  useEffect(() => {
    const getExpenseCategory = async () => {
      const expenseCategoriesData = await db.getExpenseCategory.toArray();
      setExpenseCategories(expenseCategoriesData);
    };

    const getFinancialAccountsData = async () => {
      const financialAccountsData = await db?.getFinancialAccounts?.toArray();
      setFinancialAccounts(financialAccountsData);
    };

    getExpenseCategory();
    getFinancialAccountsData();
  }, []);

  useEffect(() => {
    const run = async () => {
      validateGiftCardForm.setFieldsValue({
        amount: cart.isReturn ? Math.abs(cart.total) : "",
      });
    };
    run();
    window.addEventListener("keydown", handleKey);
    return () => {
      window.removeEventListener("keydown", handleKey);
    };
  }, []);

  useEffect(() => {
    const filterGiftCards = async () => {
      try {
        const lowerSearchTerm = searchTerm?.toLowerCase() || "";
        const giftCardData = await db.giftCardData.toArray();
        const filteredCards = giftCardItems.filter((obj) => {
          const matchingGiftCard = giftCardData.filter((giftcard) => giftcard.mProductId === obj.mProductId && giftcard.giftCardGroup === giftCardType);
          if (matchingGiftCard.length > 0) {
            const updatedObj = { ...obj, matchingGiftCard };
            if (!searchTerm) return true;
            return updatedObj?.name?.toLowerCase().includes(lowerSearchTerm) || updatedObj?.value?.includes(searchTerm);
          }
          return false;
        });
        setFilteredGiftCards(filteredCards);
      } catch (error) {
        console.error("Error filtering gift cards:", error);
      }
    };

    const filterBagData = () => {
      try {
        const lowerSearchTerm = searchTerm?.toLowerCase() || "";
        const filteredCards = addToBagProducts.filter((obj) => obj?.name?.toLowerCase().includes(lowerSearchTerm) || obj?.value?.includes(searchTerm));
        setFilteredBags(filteredCards);
      } catch (error) {
        console.error("Error filtering bag data:", error);
      }
    };

    filterGiftCards();
    filterBagData();
  }, [giftCardItems, searchTerm, giftCardType, addToBagProducts]);

  // ─── Handlers ───────────────────────────────────────────────────────────────

  const handleKey = (e) => {
    const { keyCode } = e;
    if (keyCode === 27) {
      props.setDisplayManualQtyWeightInput?.((b) => {
        if (b) {
          return !b;
        } else {
          return b;
        }
      });
    }
    if (keyCode === 87) {
      getWeightFromHardware();
    }
  };

  const getWeightFromHardware = () => {
    if (tillData.tillAccess.cwrTill.hardwareController.weighingScale !== "N") {
      axios
        .get(`${tillData.tillAccess.cwrTill.hardwareController.imageUrl}getWeight`)
        .then((resp) => {
          const responseWeight = resp.data.Weight.replace(" kg", "");
          setProductWeightModalInput(responseWeight);
        })
        .catch((e) => {
          console.error(e);
        });
    }
  };

  const handleCashManagement = (value) => {
    let formData = cashManagementForm.getFieldsValue(true);
    let currentAmount = formData.amount ? formData.amount.toString() : "";
    if (value === ".") {
      if (currentAmount.includes(".")) return;
    }
    if (formData.amount === "" && value === "x") {
      cashManagementForm.setFieldsValue({ amount: "" });
    } else if (value === "x") {
      cashManagementForm.setFieldsValue({
        amount: `${formData.amount.toString().substring(0, formData.amount.toString().length - 1)}`,
      });
    } else {
      cashManagementForm.setFieldsValue({
        amount: `${formData.amount ? formData.amount : ""}${value}`,
      });
    }
  };

  const handleAmountChange = (e) => {
    let value = e.target.value;
    value = value.replace(/[^0-9.]/g, "");
    if ((value.match(/\./g) || []).length > 1) {
      value = value.slice(0, -1);
    }
    cashManagementForm.setFieldsValue({ amount: value });
  };

  const handleCashInNote = (value) => {
    cashManagementForm.setFieldsValue({ note: value });
  };

  const selectGiftCard = async (obj) => {
    await db.giftCardData.toArray().then((giftCardData) => {
      giftCardData.map((giftcard) => {
        if (giftcard.mProductId === obj.mProductId) {
          setSelectGiftCardItem({ ...obj, ...giftcard });
          setSearchTerm("");
        }
      });
    });
    setIsGiftCardFlag(false);
    setValidateGiftCard(true);
  };

  const handleAddGiftCardAmount = (value) => {
    if (!validateGiftCard) {
      let formData = giftCardForm.getFieldsValue(true);
      if (value === "clear") {
        if (inputFocused === "redeemNumber") {
          giftCardForm.setFieldsValue({ number: "" });
          reddemNumber.focus();
        } else if (inputFocused === "pin") {
          giftCardForm.setFieldsValue({ pin: "" });
          pinNumb.focus();
        } else if (inputFocused === "amount") {
          giftCardForm.setFieldsValue({ amount: "" });
          redeemAmountNumber.focus();
        }
      } else if (value === "x") {
        if (inputFocused === "redeemNumber") {
          giftCardForm.setFieldsValue({ number: `${formData.number.toString().substring(0, formData.number.toString().length - 1)}` });
          reddemNumber.focus();
        } else if (inputFocused === "pin") {
          giftCardForm.setFieldsValue({ pin: `${formData.pin.toString().substring(0, formData.pin.toString().length - 1)}` });
          pinNumb.focus();
        } else if (inputFocused === "amount") {
          giftCardForm.setFieldsValue({ amount: `${formData.amount.toString().substring(0, formData.amount.toString().length - 1)}` });
          redeemAmountNumber.focus();
        }
      } else {
        if (inputFocused === "redeemNumber") {
          giftCardForm.setFieldsValue({ number: `${formData.number ? formData.number : ""}${value}` });
          reddemNumber.focus();
        } else if (inputFocused === "pin") {
          giftCardForm.setFieldsValue({ pin: `${formData.pin ? formData.pin : ""}${value}` });
          pinNumb.focus();
        } else if (inputFocused === "amount") {
          giftCardForm.setFieldsValue({ amount: `${formData.amount ? formData.amount : ""}${value}` });
          redeemAmountNumber.focus();
        }
      }
    } else {
      let formData = validateGiftCardForm.getFieldsValue(true);
      if (value === "clear") {
        if (inputFocused === "issueGiftCardNumber") {
          validateGiftCardForm.setFieldsValue({ number: "" });
          issueCardInput.focus();
        } else if (inputFocused === "cardPin") {
          validateGiftCardForm.setFieldsValue({ cardPin: "" });
          pinCard.focus();
        } else if (inputFocused === "issueAmount") {
          validateGiftCardForm.setFieldsValue({ amount: "" });
          issueCardAmount.focus();
        }
      } else if (value === "x") {
        if (inputFocused === "issueGiftCardNumber") {
          validateGiftCardForm.setFieldsValue({ number: `${formData.number.toString().substring(0, formData.number.toString().length - 1)}` });
          issueCardInput.focus();
        } else if (inputFocused === "cardPin") {
          validateGiftCardForm.setFieldsValue({ cardPin: `${formData.cardPin.toString().substring(0, formData.cardPin.toString().length - 1)}` });
          pinCard.focus();
        } else if (inputFocused === "issueAmount") {
          validateGiftCardForm.setFieldsValue({ amount: `${formData.amount.toString().substring(0, formData.amount.toString().length - 1)}` });
          issueCardAmount.focus();
        }
      } else {
        if (inputFocused === "issueGiftCardNumber") {
          validateGiftCardForm.setFieldsValue({ number: `${formData.number ? formData.number : ""}${value}` });
          issueCardInput.focus();
        } else if (inputFocused === "cardPin") {
          validateGiftCardForm.setFieldsValue({ cardPin: `${formData.cardPin ? formData.cardPin : ""}${value}` });
          pinCard.focus();
        } else if (inputFocused === "issueAmount") {
          if (value === "200" || value === "500" || value === "1000") {
            validateGiftCardForm.setFieldsValue({
              amount: `${formData.amount ? parseFloat(formData.amount) + parseFloat(value) : parseFloat(value)}`,
            });
          } else {
            validateGiftCardForm.setFieldsValue({ amount: `${formData.amount ? formData.amount : ""}${value}` });
          }
          issueCardAmount.focus();
        }
      }
    }
  };

  const handleCardPayment = (values) => {
    cart.cardPaymentData.manual = values;
    setCart(cart);
    props.setIsCardPaymentFlag(false);
    CardPaymentForm.resetFields();
  };

  const giftCardBalanceAmount = async () => {
    let formData = validateGiftCardForm.getFieldsValue(true);
    let setAuthTokens;
    const authHeaders = await getOAuthHeaders();
    if (authHeaders && authHeaders.access_token) {
      setAuthTokens = authHeaders.access_token;
    }
    if (formData.number !== "") {
      const data = {
        query: `query {
          checkGiftCardBalance(cardNo: "${formData.number}", cardPin: ${formData.cardPin ? `"${formData.cardPin}"` : null}){
              currentBalance
              cardGroup
              status
              message
            }
        }`,
      };
      try {
        const giftCardResponse = await checkGiftCard(data);
        if (giftCardResponse.data.data.checkGiftCardBalance.length > 0 && giftCardResponse.data.data.checkGiftCardBalance[0].status === "200") {
          const balance = giftCardResponse.data.data.checkGiftCardBalance[0].currentBalance;
          setGiftCardBalance(balance ?? 0);
        } else {
          message.error(`${giftCardResponse.data.data.checkGiftCardBalance[0].message}`);
        }
      } catch (error) {
        message.error(error);
      }
    }
  };

  const handleSelectedSaleType = (obj) => async () => {
    try {
      setSelectedSaleTypeData(obj);
      const paymentDetails = getFilteredPaymentMethods(obj?.cwrSaletype?.cwrSaletypeId || null);
      setShowPayments(paymentDetails);
      usePOSConfigStore.getState().setSaleTypeData(obj);
      setSelectedSaleType(obj?.cwrSaletype?.name);
      setIsSaleTypeFlag(false);
      changeCustomerId(obj);

      const precision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
      const saleTypeDataStore = usePOSConfigStore.getState().saleTypeData || {};
      let taxIncludeFlag = saleTypeDataStore?.customer?.istaxincluded === "Y" ? "Y" : tillData.tillAccess.csBunit.isTaxIncluded ? tillData.tillAccess.csBunit.isTaxIncluded : "Y";
      let updatedCart = isExchange ? { ...(useCartStore.getState().exchangeCart || {}) } : cart;
      updatedCart.customer = obj?.customer?.b2cCustomerId ? obj?.customer : tillData.tillAccess.csBunit.b2cCustomer;
      if (cart.items.length > 0) {
        await Promise.all(
          cart.items.map(async (ele) => {
            let addToCart = ele;
            if (addToCart?.priceList?.length > 0) {
              const saleTypeDataStore = usePOSConfigStore.getState().saleTypeData || {};
              let taxIncludeFlag =
                saleTypeDataStore?.customer?.istaxincluded === "Y" ? "Y" : tillData.tillAccess.csBunit.isTaxIncluded ? tillData.tillAccess.csBunit.isTaxIncluded : "Y";
              const selectedPrice = getApplicablePrice({
                priceList: addToCart.priceList,
                selectedUomId: addToCart.uomData[0]?.csUomId,
                sPriceListId: updatedCart.customer.sPriceListId,
                alternateUom: addToCart.alternateUom || [],
                primaryUomId: addToCart.uom || null,
              });
              if (selectedPrice && !(shouldUseBatchPrice(addToCart) && addToCart.mBatchId)) {
                addToCart.price = selectedPrice.pricestd;
                addToCart.salePrice = selectedPrice.pricestd;
                addToCart.realPrice = selectedPrice.pricestd;
                addToCart.sunitprice = selectedPrice.pricestd;
              } else if (!updatedCart.customer.sPriceListId) {
                addToCart.price = addToCart.originalPrice;
                addToCart.salePrice = addToCart.originalPrice;
                addToCart.realPrice = addToCart.originalPrice;
                addToCart.sunitprice = addToCart.originalPrice;
              }
              const addOnsPriceSum = sumBy(addToCart?.selectedAddons, "price");
              const mrp = (parseFloat(addToCart.salePrice) + addOnsPriceSum * addToCart.weight) * parseFloat(addToCart.weight);
              const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + addToCart.taxRate / 100) : mrp * (addToCart.taxRate / 100);
              addToCart.taxAmount = tax;
              addToCart.nettotal =
                taxIncludeFlag === "Y"
                  ? parseFloat((mrp - parseFloat(addToCart.discount ? addToCart.discount : 0)).toFixed(precision))
                  : parseFloat((mrp - parseFloat(addToCart.discount ? addToCart.discount : 0)).toFixed(precision)) + tax;
            }

            updatedCart = await pricingRuleController(addToCart, cart, cart, setCart, cart, orderType);
            return updatedCart;
          })
        );
      } else {
        let orderTimeDetails = usePOSConfigStore.getState().orderTimeDetails || { orderStartTime: "", orderEndTime: "", paymentStartTime: "" };
        orderTimeDetails = {
          ...orderTimeDetails,
          orderStartTime: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        };
        usePOSConfigStore.getState().setOrderTimeDetails(orderTimeDetails);
      }

      if (updatedCart?.couponInput?.length > 0) {
        let addToCart = cart.items[0];
        await Promise.all(
          updatedCart.couponInput.map(async (coupon) => {
            const matchingPricingRules = findPricingRuleById(coupon.mPricingruleId);
            if (matchingPricingRules[0].type !== "TD" && matchingPricingRules[0].type !== "TDF") {
              updatedCart = await pricingRuleController(
                addToCart,
                updatedCart,
                cart,
                setCart,
                cart,
                orderType,
                true,
                coupon.couponCode,
                coupon.referenceId,
                coupon.mPricingCouponId,
                coupon.mPricingruleId
              );
            } else {
              updatedCart = await processBillDiscounts(
                matchingPricingRules[0],
                updatedCart,
                true,
                coupon.couponCode,
                coupon.referenceId,
                coupon.mPricingCouponId,
                coupon.mPricingruleId
              );
            }
          })
        );
      }
      if (cart?.totalDiscountFlag) {
        await openPaymentModalByCustomer(updatedCart);
      }

      if (updatedCart?.manualDiscountData?.lineLevelDiscount?.length > 0) {
        updatedCart.manualDiscountData.lineLevelDiscount.map((item) => {
          const pricingRule = manualDiscountTypes[manualDiscountTypes.findIndex((md) => md.mPricingrulesId === item.pricingRule)];
          let productSelected = updatedCart.items.filter((cartItem) => cartItem.productId === item.productId);
          if (pricingRule.type === "FD") {
            CheckoutFlatDiscount(productSelected[0], pricingRule, setCart, updatedCart, orderType, updatedCart, item.discountValue);
          } else if (pricingRule.type === "PD") {
            CheckoutPercentageDiscount(productSelected[0], pricingRule, setCart, updatedCart, orderType, updatedCart, item.discountValue);
          }
        });
      }

      if (updatedCart?.manualDiscountData?.totalLevelDiscount?.length > 0) {
        updatedCart.manualDiscountData.totalLevelDiscount.map((item) => {
          const pricingRule = manualDiscountTypes[manualDiscountTypes.findIndex((md) => md.mPricingrulesId === item.pricingRule)];
          if (pricingRule.type === "TD") {
            CheckoutTotalManualDiscount(pricingRule, setCart, updatedCart, orderType, updatedCart, item.discountValue);
          }
        });
      }

      const itemSummery = {
        decimalItems: { totalQty: 0, totalAmount: 0 },
        nonDecimalItems: { totalQty: 0, totalAmount: 0 },
        itemsQty: 0,
        items: 0,
      };

      let updatedTotalTax = 0;
      let updatedTotalPrice = 0;
      let updatedTotalItemsQty = 0;
      let updatedTotalDiscounts = 0;

      updatedCart.items = updatedCart.items.map((item, i) => {
        const precision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
        const nettotalFixed = parseFloat(parseFloat(item.nettotal).toFixed(precision));
        const taxAmountFixed = parseFloat(parseFloat(item.taxAmount).toFixed(precision));
        const discountFixed = item.discount ? parseFloat(parseFloat(item.discount).toFixed(precision)) : 0;

        updatedTotalPrice += nettotalFixed;
        updatedTotalItemsQty += item.weight;
        updatedTotalTax += taxAmountFixed;
        updatedTotalDiscounts += discountFixed;

        item.discount = discountFixed;
        item.key = i;

        if (!item.isGiftCard) {
          const unitPrice = isFinite(item.nettotal / item.weight) ? (taxIncludeFlag === "Y" ? item.nettotal / item.weight / (1 + item.taxRate / 100) : item.salePrice) : 0;
          const lineTax = item.listPrice * (1 + item.taxRate / 100);
          const stdTax = item.sunitprice * (1 + item.taxRate / 100);
          const grossUnit = Math.abs(item.sunitprice) - Math.abs(item.discount) / Math.abs(item.weight);
          const netList =
            taxIncludeFlag === "Y" ? item.listPrice - parseFloat(parseFloat(item.listPrice - item.listPrice / (1 + item.taxRate / 100)).toFixed(precision)) : item.listPrice;
          const gross_list = taxIncludeFlag === "Y" ? item.listPrice : parseFloat(parseFloat(lineTax).toFixed(precision));
          const grossStd = taxIncludeFlag === "Y" ? item.sunitprice : parseFloat(parseFloat(stdTax).toFixed(precision));

          Object.assign(item, {
            linetax: nettotalFixed ? taxAmountFixed : 0,
            linenet: nettotalFixed ? parseFloat(item.nettotal - item.taxAmount).toFixed(precision) : 0,
            linegross: nettotalFixed || 0,
            linestd: nettotalFixed ? parseFloat(parseFloat(grossStd * item.weight).toFixed(precision)) : 0,
            netunit: nettotalFixed ? parseFloat(parseFloat(unitPrice).toFixed(precision)) : 0,
            listprice: nettotalFixed ? item.listPrice : 0,
            grossunit: nettotalFixed ? parseFloat(parseFloat(unitPrice).toFixed(precision)) * (item.isReturn ? -1 : 1) : 0,
            grossstd: nettotalFixed ? grossStd : 0,
            grosslist: nettotalFixed ? gross_list : 0,
            netList: nettotalFixed ? netList : 0,
            unitPrice: nettotalFixed ? parseFloat(parseFloat(unitPrice).toFixed(precision)) : 0,
            taxAmount: nettotalFixed ? taxAmountFixed : 0,
          });
        }

        if (Array.isArray(item.children) && item.children.length > 0) {
          item.children.forEach((child) => {
            const isDecimal = child.uomData?.[0]?.decimal === "Y" || child.isDecimal;
            const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";
            itemSummery.itemsQty += child.weight;
            itemSummery.items += 1;
            itemSummery[summaryKey].totalQty += child.weight;
            itemSummery[summaryKey].totalAmount += parseFloat(parseFloat(child.nettotal).toFixed(precision));
          });
        } else {
          const isDecimal = item.uomData?.[0]?.decimal === "Y" || item.isDecimal;
          const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";
          itemSummery.itemsQty += item.weight;
          itemSummery.items += 1;
          itemSummery[summaryKey].totalQty += item.weight;
          itemSummery[summaryKey].totalAmount += parseFloat(parseFloat(item.nettotal).toFixed(precision));
        }
        return item;
      });

      const sumLineTotals = (lines) => {
        let totalLineGross = 0;
        let totalLineTax = 0;
        lines.forEach((line) => {
          totalLineGross += line.nettotal;
          totalLineTax += line.taxAmount;
        });
        return { totalLineGross, totalLineTax };
      };

      const adjustOrderTotals = (order, lines) => {
        const { totalLineGross, totalLineTax } = sumLineTotals(lines);
        let adjustedOrderGross = order.total;
        let adjustedOrderTax = order.tax;
        const grossDifference = totalLineGross - adjustedOrderGross;
        const taxDifference = totalLineTax - adjustedOrderTax;
        if (Math.abs(grossDifference) > 0.01) {
          adjustedOrderGross += grossDifference;
        }
        if (Math.abs(taxDifference) > 0.01) {
          adjustedOrderTax += taxDifference;
        }
        return { ...order, total: adjustedOrderGross, tax: adjustedOrderTax };
      };

      updatedCart = adjustOrderTotals(updatedCart, updatedCart.items);
      const allItemsInCart = (updatedCart.items || []).flatMap((item) => (Array.isArray(item.children) && item.children.length > 0 ? item.children : [item]));
      const updatedTotalStd = allItemsInCart.reduce((sum, item) => sum + (item.linestd || 0), 0);
      let finalCartObj = {
        ...updatedCart,
        items: [...updatedCart.items],
        discount: updatedTotalDiscounts,
        totalQty: updatedTotalItemsQty,
        total: updatedTotalPrice,
        tax: updatedTotalTax,
        totalStd: updatedTotalStd,
      };
      if (isExchange) {
        useCartStore.getState().setExchangeCart(finalCartObj);
      } else {
        setCart({ ...finalCartObj });
      }
      if (searchInputRef?.current) {
        searchInputRef?.current.focus();
      }
    } catch (e) {
      console.debug("Error", e);
    }
  };

  const errorMessage = (modalTitle, modalContent) => {
    Modal.error({
      title: modalTitle,
      content: modalContent,
    });
  };

  const verifyLoyalty = async () => {
    try {
      const verifyLoyaltyRedemptionResponse = await verifyLoyaltyRedemption(cart.customer.cwrCustomerId, tillData.tillAccess.csBunit.csBunitId, loyaltyInputValue, cart?.total);
      if (verifyLoyaltyRedemptionResponse.status === 200) {
        const status = verifyLoyaltyRedemptionResponse.data.data.verifyLoyaltyRedemption.status;
        const redemptionMessage = verifyLoyaltyRedemptionResponse.data.data.verifyLoyaltyRedemption.message;
        if (status === "200") {
          loyaltyInputRef.current?.blur();
          setShowOtpPopup(true);
        } else if (status === "201") {
          message.error(redemptionMessage);
        }
      }
    } catch (err) {
      console.error(err);
      message.error(`${messages.errors.loyalty.loyalty_redemption_failed}`);
    }
  };

  const handleDiscountTypeChange = (value) => {
    setSelectedManualDiscountType(value);
    setTimeout(() => {
      valueInputRef.current?.focus();
    }, 10);
  };

  const removeCouponConfirmation = (coupon) => {
    Modal.confirm({
      title: "Clear Coupon?",
      icon: <ExclamationCircleOutlined />,
      content: <div>Are you sure you want to remove this coupon?</div>,
      okText: "Yes",
      cancelText: "No",
      autoFocusButton: null,
      okButtonProps: { style: { display: "inline-block" } },
      onOk() {
        removeCoupon(coupon);
      },
      onCancel() {},
    });
  };

  // ─── Offer tag helpers ──────────────────────────────────────────────────────

  const TAG_COLORS = ["#3b82f6", "#22c55e", "#f97316", "#8b5cf6", "#ef4444", "#06b6d4", "#ec4899"];

  const getColorById = (id) => {
    if (!id) return TAG_COLORS[0];
    let hash = 0;
    for (let i = 0; i < id.length; i++) {
      hash = id.charCodeAt(i) + ((hash << 5) - hash);
    }
    return TAG_COLORS[Math.abs(hash) % TAG_COLORS.length];
  };

  const resolveTagMeta = (rule) => {
    const TAG_ICONS_MAP = {
      ITEM: "GiftOutlined",
      BILL: "ShoppingCartOutlined",
      BXGY: "TagsOutlined",
      COMBO: "AppstoreOutlined",
      DEFAULT: "TagsOutlined",
      BXPY: "CreditCardOutlined",
    };
    const TYPE_TO_TAG = { PD: "ITEM", FD: "BILL", QD: "ITEM", TD: "BILL", TDF: "BILL", EXD: "BILL", PA: "ITEM", XGY: "BXGY", BXD: "BXPY", BXS: "BXPY", PK: "COMBO" };
    const type = rule?.type;
    return {
      label: TYPE_TO_TAG[type] || type || "DEFAULT",
      group: TYPE_TO_TAG[type] || "DEFAULT",
      color: getColorById(rule?.mPricingrulesId),
    };
  };

  const modalTagMeta = resolveTagMeta(selectedOffer);

  const formatDate = (date) => (date ? dayjs(date).format("DD/MM/YYYY") : "No Expiry");

  const getDiscountText = (rule) => {
    if (rule.discountType === "V") {
      return rule.amountDiscount ? `₹${rule.amountDiscount}` : "Value Discount";
    }
    if (rule.discountType === "P") {
      return rule.percentageDiscount ? `${rule.percentageDiscount}%` : "Percentage Discount";
    }
    return "-";
  };

  const handleViewDetails = (offer) => {
    setSelectedOffer(offer);
    setOfferDetailsOpen(true);
  };

  const getApplicableDays = (rule) => {
    if (!rule) return ["All"];
    if (rule.timeSpecific === "N") return ["All"];
    const DAY_MAP = [
      { key: "sunday", label: "Sunday" },
      { key: "monday", label: "Monday" },
      { key: "tuesday", label: "Tuesday" },
      { key: "wednesday", label: "Wednesday" },
      { key: "thursday", label: "Thursday" },
      { key: "friday", label: "Friday" },
      { key: "saturday", label: "Saturday" },
    ];
    const activeDays = DAY_MAP.filter((day) => rule[day.key] === "Y").map((day) => day.label);
    return activeDays.length ? activeDays : ["All"];
  };

  // ─── Batch table helpers ─────────────────────────────────────────────────────

  const compactTable = {
    header: {
      cell: (cellProps) => (
        <th
          {...cellProps}
          style={{
            background: "#fff",
            borderBottom: "1px solid #E5E7EB",
            fontSize: "10px",
            fontWeight: 500,
            color: "#111827",
            padding: "6px 8px",
            height: "28px",
            whiteSpace: "nowrap",
            ...cellProps.style,
          }}
        />
      ),
    },
    body: {
      cell: (cellProps) => (
        <td
          {...cellProps}
          style={{
            borderBottom: "1px solid #F3F4F6",
            fontSize: "11px",
            fontWeight: 400,
            color: "#374151",
            padding: "6px 8px",
            height: "26px",
            whiteSpace: "nowrap",
            ...cellProps.style,
          }}
        />
      ),
    },
  };

  const columns = [
    {
      title: "",
      width: 40,
      render: (_, row) => <Radio checked={selectedBatch?.mBatchId === row?.mBatchId} onChange={() => setSelectedBatch(row)} />,
    },
    {
      title: "Batch Number",
      dataIndex: "batchno",
      render: (v) => <span style={{ fontWeight: 500, fontSize: "11px", whiteSpace: "normal", wordBreak: "break-word", lineHeight: "14px" }}>{v || "-"}</span>,
    },
    {
      title: "MRP",
      dataIndex: "mrpPrice",
      render: (v) => (
        <span style={{ color: "#6B7280", fontSize: "11px" }}>
          {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
          {Number(v ?? 0).toLocaleString()}
          {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
        </span>
      ),
    },
    {
      title: "Batch Rate",
      dataIndex: "listPrice",
      render: (v) => (
        <span style={{ color: "#6B7280", fontSize: "11px" }}>
          {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
          {Number(v ?? 0).toLocaleString()}
          {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
        </span>
      ),
    },
    {
      title: "Stock",
      dataIndex: "stock",
      render: (v) => <span style={{ color: "#6B7280", fontSize: "11px" }}>{v ?? 0}</span>,
    },
    {
      title: "Status",
      dataIndex: "stock",
      render: (v) => (
        <span
          style={{
            display: "inline-block",
            padding: "2px 10px",
            borderRadius: "999px",
            backgroundColor: "#F3F4F9",
            color: "#111827",
            fontWeight: 500,
            fontSize: "10px",
            lineHeight: "16px",
          }}
        >
          {v > 0 ? "In Stock" : "Out of Stock"}
        </span>
      ),
    },
  ];

  return {
    // state
    showOtpPopup,
    setShowOtpPopup,
    offerDetailsOpen,
    setOfferDetailsOpen,
    selectedOffer,
    setSelectedOffer,
    expenseCategories,
    financialAccounts,
    externalCoupons,
    selectedBatch,
    setSelectedBatch,
    selectedQty,
    setSelectedQty,
    saleTypeData,
    filteredGiftCards,
    filtredBags,
    focusedField,
    setFocusedField,
    // refs
    amountInputRef,
    salesRepModalInputRef,
    authorizationRef,
    valueInputRef,
    // handlers
    handleKey,
    getWeightFromHardware,
    handleCashManagement,
    handleAmountChange,
    handleCashInNote,
    selectGiftCard,
    handleAddGiftCardAmount,
    handleCardPayment,
    giftCardBalanceAmount,
    handleSelectedSaleType,
    errorMessage,
    verifyLoyalty,
    handleDiscountTypeChange,
    removeCouponConfirmation,
    // offer helpers
    modalTagMeta,
    formatDate,
    getDiscountText,
    handleViewDetails,
    getApplicableDays,
    // batch helpers
    compactTable,
    columns,
  };
};

export default useRetailModalsLogic;
